import { State } from '../rootReducer';

export function getTag(state: State) {
    return state.tag.data;
}

export function isLoading(state: State) {
    return state.tag.isLoading;
}
